export const initializeVolumePricing = () => {
  document.addEventListener("click", function (e) {
    const target = e.target;
    if (!target.closest(".volume-pricing-wrapper")) {
      document
        .querySelectorAll(".volume-pricing-wrapper")
        .forEach(function (wrapper) {
          wrapper.classList.remove("opened");
        });
    } else {
      e.preventDefault();
      const clickedWrapper = target.closest(".volume-pricing-wrapper");
      const isOpened = false;
      clickedWrapper.classList.contains("opened");
      document
        .querySelectorAll(".volume-pricing-wrapper")
        .forEach(function (wrapper) {
          wrapper.classList.remove("opened");
        });
      if (!isOpened) {
        clickedWrapper.classList.add("opened");
      }
    }
  });
};
